import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { MenuItem, Select, TableSortLabel, SvgIcon } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast, { Toaster } from "react-hot-toast";
import {
    GridToolbarContainer,
    GridToolbarExport,
} from "@mui/x-data-grid";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";
import IconButton from "@mui/material/IconButton";
import {
    Button,
    Grid,
    Menu,
    InputLabel,
    TextField,
    ListItemIcon,
    Checkbox,
    ListItemText,
} from "@material-ui/core";
import { useHistory, useLocation, Link } from "react-router-dom";
import {
    getDate,
    ViewCdtParticularPath,
    searchFilter,
    handleSort,
    getToday,
    getTime,
    editProspectPath,
    getDateTime,
    get12HoursTime,
    ViewCdtReportsPath
} from "../utils/varialbles";
import http from "../services/reportsPath";
import SearchBar from "material-ui-search-bar";
// import Filter from '../components/filerComponent';
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
// import useFilter from "../components/filterComponent";
// import useFilter from "../components/multifilterComponent";
import useFilter from "../components/sideFilter";
import { textAlign } from "@mui/system";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditSharpIcon from "@material-ui/icons/EditSharp";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FormControl from "@material-ui/core/FormControl";
import DehazeIcon from "@material-ui/icons/Dehaze";
import MenuIcon from "@material-ui/icons/Menu";
import { PanoramaSharp } from "@material-ui/icons";
import { usePersistentState } from 'react-persistent-state'

// import { browserHistory } from 'react-router'
import { browserHistory } from "react-router-dom";
import { createHashHistory } from "history";

const anchorEl = 1;
const setAnchorEl = 2;

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    table: {
        field: "Resizing",
        title: "Column Width",
        cellStyle: {
            whiteSpace: "nowrap",
            width: "20%",
        },
    },
    tableRow: {
        "&:hover": {
            cursor: "pointer",
        },
    },
    indeterminateColor: {
        color: "#f50057",
    },
    selectAllText: {
        fontWeight: 500,
    },
    selectedAll: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
        },
    },
    radio: {
        "&$checked": {
            color: "#57bf74",
        },
    },
    checked: {},
});

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport csvOptions={{ allColumns: true }} />
        </GridToolbarContainer>
    );
}

let uniqueApiNames = {};

export default function ViewCdtReports() {
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(
        10
    );
    const [menuCol, setShowMenuCol] = useState(false);
    // const [multipleProspect, setMultipleProspect] = useState([])

    const [finalColumnNames, setFinalColumnNames] = useState([])
    const [rows, setRows] = useState([]);
    const [finalColumns, setFinalColumns] = useState([])
    const [searched, setSearched] = useState("");
    const [orignalRows, setOriginalRows] = useState([]);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("");
    const [multipleSelected, setMultipleSelected] = useState('')
    const [profile, setProfile] = useState({})
    const [isCheckboxSelected, setIsCheckboxSelected] = useState([])

    // const [anchorEl, setAnchorEl] = React.useState(false);
    const location = useLocation();
    const myparam = location.state;
    const columnId = location.columnId;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const chistory = createHashHistory();
    // const isMenuOpen = Boolean(anchorEl);
    const form = {
        status: [],
        get_back_date: "",
        assigned_executive__empfname: "",
        cust__createddt: "",
        cust__createddt__condition: "lte",
        get_back_date__condition: "lte",
    };
    const cancelSearch = () => {
        // setSearched("");
        // requestSearch(searched);
    };
    const [formObject, setFormObject] = React.useState(form);
    let history = useHistory();
    const handleChange = (e) => {
        setFormObject({
            ...formObject,
            [e.target.name]: e.target.value,
        });
    };

    // const [custTask, setCustTask] = useState([]);
    // (custTask);

    // const renderList = (props) =>{
    //   let {value} = props;
    // }

    const [columns, setColumns] = useState([
        {
            headerName: "Number",
            id: "mobile",
            show: true,
            minWidth: 200,
        },
        {
            headerName: "Signup Up Date",
            id: "signup_date",
            show: true,
            minWidth: 200,
            format: 'Date'
        },
        {
            headerName: "RM Name",
            id: "rm",
            show: true,
            minWidth: 200,
        },
        {
            headerName: "City",
            id: "city",
            show: true,
            minWidth: 200,
        },
        {
            headerName: "Last Login",
            id: "lastlogin",
            show: true,
            minWidth: 200,
            format: 'Date'

        },
    ]);

    // (columns);
    let staticCols = ["Alpha", "Advisedval", "Currentval", "Gainper", "Investedval"];
    let finalDropCols = columns.filter((item) => {
        if (!staticCols.includes(item.headerName)) {
            return item.headerName;
        }
    });
    // (finalDropCols);

    const gridOptions = {
        filter: "false",
        pagination: false,
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center",
        },
        variant: "menu",
    };

    const [selected, setSelected] = useState([]);
    // (selected);

    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);
        let rowsTemp = [...orignalRows];
        setPage(0);
        // (searchedVal);
        const query = searchedVal ? searchedVal : searched;
        getData(query);
        // setRows(searchFilter(searchedVal, rowsTemp));
    };

    const openFilter = (e) => {
        // let currentTarget = e.currentTarget;
        // (Boolean(currentTarget));
        // setAnchorEl(true);
        setIsMenuOpen(true);
    };

    // const [clearFilter, appliedFilter, setAppliedFilter, filterState, setFilterState, filterList, setFilterList, Filter, getFilterParams] = useFilter('prospect_manager');
    const [Filter, filterString, passFilters, passData] =
        useFilter("prospect_manager",);
    // (filterString);

    const [totalRowCount, setTotalRowCount] = React.useState(0);
    const getPaginationURL = (url, newQuery) => {
        const query = newQuery ? newQuery : searched;

        // var selectedRows=[...datas];
        // ('am datas', selectedRows);


        var retrievedObject = localStorage.getItem('testObject');
        if (query) {
            return `${url}?page=${page + 1
                }&rowsPerPage=${rowsPerPage}&search=${query}`;
        } else {
            return (

                `${url}?date=${location.state.date}`

            )


        }
    };

    const getData = (newQuery) => {
        toast.loading("Please wait...");

        const baseURL = "referral_yettosub";
        setOriginalRows([]);
        setRows([]);
        // const filterParams = getFilterParams();
        //  (filterString);
        // localStorage.setItem("selectedpropspectfilter", filterString);
        // var strings=localStorage.getItem("selectedpropspectfilter");
        // var filterColumns= [];
        // filterColumns.push(filterString)
        // localStorage.setItem("users", JSON.stringify(filterColumns));
        // ('am base', filterColumns, filterString);
        http
            .get(getPaginationURL(baseURL, newQuery) + filterString)

            .then((response) => {
                toast.dismiss();
                // ("am data", response);
                // ("rowoow");
                // (response);
                // http.get("/investment_manager").then((response) => {
                if (
                    response &&
                    response.data &&
                    response.data.statusCode === 0 &&
                    Array.isArray(response.data.data)
                ) {
                    // ("ooooooo");
                    if (!filterString) passFilters(response.data.filter || []);

                    let tempDta = response.data.data;
                    setOriginalRows(tempDta);
                    setRows(response.data.data);
                    // setOriginalRows(response.data.data)

                    let finalrows = tempDta.map((item) => {
                        // (item);
                        const obj = item;
                        // (obj);

                        const swapValue = (obj) => {
                            Object.keys(obj).forEach((key) => {
                                // if (!obj[key]) {
                                //     obj[key] = "N/A";
                                // }
                            });
                        };
                        swapValue(obj);
                        // (obj);
                        return item;
                    });



                    let tempRows = [];
                    // let tempTasks = tempDta.map(item=>item.custtasks);
                    // setCustTask(tempTasks);

                    let finalData = [];
                    let tempStatusDta = tempDta.map((item, index) => {
                        const swapValue = (item) => {
                            Object.keys(item).forEach((key) => {
                                //(Object.keys(item));
                                // if (!item[key]) {
                                //     item[key] = "N/A";
                                // }
                            });
                        };
                        swapValue(item);


                        if (item.last_login === null) {
                            finalData.push(item.last_login = "N/A")

                        }
                        else {
                            finalData.push(item.last_login)

                        }

                        if (item.signed_up === null) {
                            finalData.push(item.signed_up = "N/A")

                        }
                        else {
                            finalData.push(item.signed_up)

                        }
                        if (item.city === null) {
                            finalData.push(item.city = "N/A")

                        }
                        else {
                            finalData.push(item.city)

                        }

                        finalData.push(
                            (item.signed_up = getDateTime(item.signed_up))
                        );

                        return item;
                    });

                    setOriginalRows(tempDta);
                    setRows(tempDta);
                    setTotalRowCount(response.data.totalRowCount);
                } else {
                    setOriginalRows([]);
                    setRows([]);
                    setTotalRowCount(0);
                }
            });
    };
    useEffect(() => {
        localStorage.setItem('misreportsrowsperpage', rowsPerPage)
        localStorage.removeItem("investmentFilter");
        localStorage.removeItem("prospectFilter");
        localStorage.removeItem("ticketFilter");
        localStorage.removeItem("internalFilter")
        localStorage.removeItem("prospectFilter")
        localStorage.removeItem('selectedinvestorfiltersdata')


        getData();
        // rmNamesList()
        // getProfileDetails()



    }, [page, rowsPerPage, filterString, totalRowCount]);

    // const rmNamesList = () => {
    //     http.get("rmchange").then((res) => {
    //         // setCountryValidations(res.data.Data);
    //         setMultipleProspect(res.data.rms);

    //     }).catch((err) => {
    //         ('am eroor');
    //     })
    // }

    const getProfileDetails = () => {
        http.get("profile_details").then((res) => {

            if (
                res &&
                res.data &&
                res.data["Profile details"] &&
                Array.isArray(res.data["Profile details"]) &&
                res.data["Profile details"].length > 0
            ) {
                setProfile(res.data["Profile details"][0]);

            }
        }).catch((err) => {
        })
    }
    const handleLangChange = (e) => {
        setMultipleSelected(e.target.value);
    }
    const isSelected = (id) => isCheckboxSelected.indexOf(id) !== -1;

    const handleClickCheckbox = (event, id) => {
        const selectedIndex = isCheckboxSelected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(isCheckboxSelected, id);
            //   getState(true)

        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(isCheckboxSelected.slice(1));
            //   getState(false)

        } else if (selectedIndex === isCheckboxSelected.length - 1) {
            newSelected = newSelected.concat(isCheckboxSelected.slice(0, -1));
            //   getState(true)
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                isCheckboxSelected.slice(0, selectedIndex),
                isCheckboxSelected.slice(selectedIndex + 1),
                // getState(false)

            );
        }
        setIsCheckboxSelected(newSelected);
        // getSelectedId(newSelected)

    };
    const onSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = orignalRows.map((n) => n.id);
            setSelected(newSelecteds);
            setIsCheckboxSelected(newSelecteds)

            return;
        }
        setIsCheckboxSelected([])


    }

    const postingRmnamesList = () => {
        // ('am ids', selectedId, multipleSelected);

        if (multipleSelected === "" || isCheckboxSelected.length === 0) {
            toast.error('Please select the RM Names list')
        }
        else {
            const baserm = "/rmchange"
            http.post(`${baserm}?emp_id=${multipleSelected}&cust_id=${isCheckboxSelected}`,).then((res) => {
                toast.success(res.data.rms);
                // ('am ids', selectedId);
                getData()
                setIsCheckboxSelected([])

            }).catch((err) => {
            })
        }
    }
    const handleColChange = (event) => {
        const value = event.target.value;
        // (value);
        setSelected(value);
        let newCols = columns.map((item) => {
            let findSelect = value.find((list) => {
                if (list === item.headerName) {
                    // return item;
                    item.show = true;
                    // (item);
                    return item;
                    // setColumns(item);
                } else {
                    item.show = false;
                }
            });
            return newCols;
        });

        // let parsedVal = JSON.parse(value);
        localStorage.setItem("slectProspectCols", value);
    };



    const saveColumns = () => {
        let finalCols = staticCols.concat(selected);
        let sendFinalCols = [...new Set(finalCols)];
        // (finalCols);
        // (sendFinalCols);

        let finalObjet = {
            emp_id: localStorage.getItem("employee_id"),
            columns: sendFinalCols,
        };
        // ('am final object', finalObjet)

        http
            .post("/prospectempcolumns", finalObjet)
            .then((response) => {
                if (response.data.statusCode === 0) {
                    toast.success(response.data.data);
                    setShowMenuCol(false);
                } else {
                    toast.error("Columns not saved!");
                }

                // setFromObject(form)
            })
            .catch((error) => { console.log('error') });

    };

    // (rows);
    // (orignalRows);

    const applyFilter = (e) => {

        let tempObject = { ...formObject };
        let tempORows = [...orignalRows];
        let filter = filterData(tempObject, tempORows, columns);
        setRows(filter);
        setPage(0);

    };
    const handleChangePage = (event, newPage) => {
        // (newPage);
        setPage(newPage);
    };

    const handleMenuClose = () => {

        setIsMenuOpen(false);
    };
    const handleRequestSort = (e, property, format) => {
        let isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        let tempRows = [...rows];
        let finalRows = handleSort(property, format, tempRows, isAsc);
        setRows(finalRows);
        setPage(0);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const viewProspectDetails = (date, country) => {
        // object.page = page;
        const sendToparticularCDT = {
            "date": date,
            "country": country
        }
        // history.push(
        //     {
        //         pathname: ViewCdtParticularPath,
        //         state: sendToparticularCDT,

        //     },
        //     "_blank"
        // );

    };

    // (myparam);

    const editProspect = (object) => {
        // (object);
        object.page = page;

        history.push({
            pathname: editProspectPath,
            state: object,
        });
    };


    const showMenuFilter = (e) => {
        setShowMenuCol((val) => !val);
    };

    // (columns);

    const gotoMisresearchCards = () => {
        history.push({
            pathname: ViewCdtReportsPath,
            state: location.columnId
        })
    }
    let filteredCol = columns.filter(data => {
        if (data.show) { return data; }
    })

    return (
        <>
            <Paper className={classes.root}>
                <>
                    <Button
                        variant="outlined"
                        color="default"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={gotoMisresearchCards}
                    >
                        Back
                    </Button>
                </>
                <div className="prospectsearchfilterboth">
                    <div className="prospectsearch">
                        <SearchBar
                            value={searched}
                            onChange={(searchVal) => requestSearch(searchVal)}
                            onCancelSearch={() => cancelSearch()}

                        />
                        {/* <div>

                            <Select
                                displayEmpty
                                labelId="statusLable"
                                id="statusSelect"
                                variant="outlined"
                                className={classes.select}
                                value={multipleSelected ? multipleSelected : ''}
                                onChange={handleLangChange}
                                style={{
                                    width: '210px', marginLeft: '10px',
                                }}
                            >
                                <MenuItem value=""> RMNames List</MenuItem>
                                {multipleProspect.map((option) => {
                                    return (
                                        <MenuItem
                                            value={option.id}
                                            key={option.id}
                                        >
                                            {option.empfname}
                                        </MenuItem>
                                    );
                                })}

                            </Select>
                            <Button variant="contained" color="primary" style={{ marginLeft: 20, borderRadius: 60 }}
                                //  startIcon={<AddCircleOutlineIcon />}
                                className={'addBtn'}

                                onClick={postingRmnamesList}
                            >Update</Button>
                        </div> */}
                    </div>

                    <div container>
                        <div>
                            {/* <tab />   // Need To Comment This           */}
                            <TablePagination
                                rowsPerPageOptions={[10, 50, 100, 500]}
                                component="div"
                                count={orignalRows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            // style={{width:'27rem'}}
                            />
                        </div>
                    </div>
                    {/* <div style={{ display: "flex", cursor: "pointer" }}>

                        <span onClick={showMenuFilter}>
                            Columns

                        </span>
                        <FormControl className={classes.formControl}>

                            {menuCol ? (
                                <div style={{ display: "flex" }}>
                                    <Select
                                        labelId="mutiple-select-label"
                                        multiple
                                        value={selected}
                                        onChange={handleColChange}
                                        // renderValue={(selected) => selected.join(", ")}
                                        renderValue={(selected) => null}
                                        MenuProps={MenuProps}
                                    >
                                        {finalDropCols.map((option) => (
                                            <MenuItem
                                                key={option.headerName}
                                                value={option.headerName}
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        checked={selected.indexOf(option.headerName) > -1}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText primary={option.headerName} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Button
                                        style={{ marginLeft: "10px" }}
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        onClick={saveColumns}
                                    >
                                        Save
                                    </Button>
                                </div>
                            ) : (
                                <>
                                    <FilterListSharpIcon
                                        style={{ marginTop: 0 }}
                                        onClick={showMenuFilter}
                                    />

                                </>

                            )}
                        </FormControl>
                    </div> */}

                    {/* <div
                        style={{ display: "flex", position: "relative" }}
                        className="tfilter"
                    >
                        <div>
                            <span style={{ margin: "0px 15px", display: "inline-block" }}>
                                Filter
                            </span>
                            <SvgIcon
                                style={{ cursor: "pointer", verticalAlign: "middle" }}
                                onClick={openFilter}

                                title={"filter"}
                            >

                                <FilterLogo />
                            </SvgIcon>
                            <Filter
                                data={passData}
                                setOpen={handleMenuClose}
                                isMenuOpen={isMenuOpen}
                                // selectedFilter={filterString}
                                style={{ border: "3px solid black" }}
                            />
                        </div>
                    </div> */}
                </div>

                {/* <MaterialTable
        columns={columns}
        data={orignalRows}
        style={{ fontSize: 12 }}
        onRowClick={(event, rowData) => viewProspectDetails(rowData)}
        options={{ filtering: false, columnsButton: true, search: false, paging: false, pageSizeOptions: [10, 50, 100, 500], actionsColumnIndex: -1, fixedColumns:{left:2} selection: true }}
        title=""
      /> */}

                {/* <DataGrid
                    columns={filteredCol}
                    rows={orignalRows}
                    getRowId={(row) => row.userid}
                    // pageSize={5}
                    // rowsPerPageOptions={false}
                    // checkboxSelection
                    //onRowClick={(event, rowData) => viewProspectDetails(rowData)}
                    style={{ cursor: "pointer" }}
                    onRowDoubleClick={(param) => viewProspectDetails(param.row)}
                    options={gridOptions}
                    autoHeight
                // components={{
                //   Toolbar: CustomToolbar,
                // }}
                // initialState={{ pinnedColumns: { left: ['actions']} }}
                /> */}

                <TableContainer className={classes.container}>

                    <Table stickyHeader aria-label="sticky table" size="small">

                        <TableHead>
                            <TableRow

                            // key={.id}
                            >
                                {/* <TableCell padding="checkbox" style={
                                    {
                                        textAlign: "center"
                                    }
                                }>
                                    {
                                        (profile.empdept === "CTO" || profile.empdept === "CEO" || profile.empdept === "Sales Manager") ?
                                            <Checkbox
                                                color="primary"
                                                numSelected={isCheckboxSelected.length}
                                                style={{ textAlign: 'center' }}

                                                onChange={onSelectAllClick}
                                                inputProps={{
                                                    "aria-label": "select all desserts",
                                                }}
                                            />

                                            : ""


                                    }

                                </TableCell> */}

                                {filteredCol.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                        className='prospect_table'
                                    >
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? order : "asc"}
                                            onClick={(e) =>
                                                handleRequestSort(e, column.id, column.format)
                                            }
                                        >
                                            {column.headerName}
                                        </TableSortLabel>

                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>



                            {
                                orignalRows.length !== 0 ? (
                                    <>
                                        {orignalRows
                                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                const isSelecteds = isSelected(row.id);
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row.id}
                                                        aria-checked={isSelecteds}
                                                        selected={isSelecteds}
                                                        className='prospecttable'

                                                    >
                                                        {/* <TableCell padding="checkboox">
                                                            {
                                                                (profile.empdept === "CTO" || profile.empdept === "CEO" || profile.empdept === "Sales Manager") ?
                                                                    <Checkbox
                                                                        // indeterminate={numSelected > 0 && numSelected < rowCount}
                                                                        //checked={numSelected === rowCount}
                                                                        // onChange={onSelectAllClick}
                                                                        color="primary"
                                                                        className="selectCheckbox"
                                                                        // checked={numSelected === rowCount}
                                                                        checked={isSelecteds}

                                                                        numSelected={isCheckboxSelected.length}
                                                                        onClick={event => handleClickCheckbox(event, row.id)}

                                                                    /> : ""
                                                            }

                                                        </TableCell> */}
                                                        {filteredCol.map((column, index) => {
                                                            const value = row[column.id];
                                                            return (
                                                                <TableCell
                                                                    key={index + column.id}
                                                                    align={column.align}
                                                                    onDoubleClick={() => viewProspectDetails(row)}

                                                                >
                                                                    {column.format && typeof value === "number" ? (
                                                                        column.format(value)
                                                                    ) : column.id === "detailsButton" ? (
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            style={{ borderRadius: 20 }}
                                                                        // onClick={() => viewDetails(row)}
                                                                        >
                                                                            View Details
                                                                        </Button>
                                                                    ) : column.format === "Date" ? (
                                                                        getDate(value)
                                                                    ) : column.operation &&
                                                                        column.operation === "concate" ? (
                                                                        value + column.operand + row[column.with]
                                                                    ) : column.type &&
                                                                        column.type === "link" &&
                                                                        value ? (
                                                                        <Link
                                                                            variant="body2"
                                                                            // onClick={(e) => viewDetails(row)}
                                                                            onClick={(e) => viewProspectDetails(row)}

                                                                            gutterBottom
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {value}
                                                                        </Link>
                                                                    ) : column.type &&
                                                                        column.type === "attach" &&
                                                                        value ? (
                                                                        <Link
                                                                            // href={staticFiles + value}
                                                                            target="_blank"
                                                                            variant="body2"
                                                                            gutterBottom
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {value}
                                                                        </Link>
                                                                    ) :


                                                                        (

                                                                            value === null ? 'N/A' : value
                                                                        )


                                                                    }

                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>
                                                );
                                            })}
                                    </>
                                ) : (
                                    <TableCell colspan="7" style={{ "text-align": "center", margin: "10px 0px" }} >
                                        Records Not Available</TableCell>


                                )
                            }

                        </TableBody>
                    </Table>
                </TableContainer>


                <div>
                    {/* <tab />   // Need To Comment This           */}
                    <TablePagination
                        rowsPerPageOptions={[10, 50, 100, 500]}
                        component="div"
                        count={orignalRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    // style={{width:'27rem'}}
                    />
                </div>
            </Paper>
        </>
    );
}

